import _axios from '@/util/httpConfig.js'

// 获取口译笔译
export const interpreterDocumentTranslation = (moduleCode, tenantCode) => {
  let data = {
    moduleCode,
    tenantCode: '96F307B9D0EDF9F',
    appCode: 'APPAFBB8CD316AFF62'
  }
  return _axios('POST',`/common-content/contentNews/list`, data)
}

// 获取口译服务
export const getInterpreter = () => {
  return _axios('GET', `/common-content/contentNews/get?contentCode=RESF27EF67D23ECEAC&tenantCode=96F307B9D0EDF9F`)
}

export  const getInfos = (contentCode) => {
  return _axios('GET',`common-content/contentNews/get?contentCode=${contentCode}&tenantCode=96F307B9D0EDF9F`)
}
// 获取合作机构及客户
export const getCiac = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","moduleCode":"RES5E2FB7D5BF0F15F","moduleNavCode":"","pageNo":1,"pageSize":10,"picName":"","picStatus":"","status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentPic/list','' ,data)
}
// 获取成功案例
export const getSuccess = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","moduleCode":"RES10F0CBFDE9581F8","moduleNavCode":"","pageNo":1,"pageSize":10,"picName":"","picStatus":"","status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentPic/list','' ,data)
}
// 获取合作机构及客户详情｜成功案例图片
export const getCommonDetail = (picCode, tenantCode) => {
  return _axios('GET', `/common-content/contentPic/get?picCode=${picCode}&tenantCode=${tenantCode}`)
}

// 获取信息咨询
export const getInfo = () => {
  const data = {"appCode":"APPAFBB8CD316AFF62","contentStatus":"","contentTitle":"","moduleCode":"RESBF584279D8E3768","moduleNavCode":"","pageNo":0,"pageSize":0,"status":"","tenantCode":"96F307B9D0EDF9F","typeCode":""}
  return _axios('POST', '/common-content/contentNews/list','' ,data)
}
// 获取信息咨询详情
export const getInfoetail = () => {
  return _axios('GET', `/common-content/contentNews/get?picCode=RES9780D2E96E8AFA5&tenantCode=96F307B9D0EDF9F`)
}



// WEBPACK FOOTER //
// ./src/api/translation.js